/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { isMessage } from '../../lib/utils';

import RoundedButton from '../buttons/Rounded';
import CircledPlus from '../icons/CircledPlus';
import IconLink from '../partials/IconLink';
import Link from '../partials/Link';

import styles from '../../../styles/headers/sticky.module.scss';

const propTypes = {
    title: PropTypes.node,
    link: PropTypes.oneOfType([AppPropTypes.link, PropTypes.string]),
    withButton: PropTypes.bool,
    buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    innerClassName: PropTypes.string,
    isDark: PropTypes.bool,
    children: PropTypes.bool,
    withRef: PropTypes.bool,
};

const defaultProps = {
    title: null,
    link: null,
    withButton: false,
    buttonLabel: null,
    isDark: false,
    className: null,
    innerClassName: null,
    children: null,
    withRef: false,
};

const StickyHeader = ({ title, link, withButton, buttonLabel, className, children, isDark }) => {
    const { label = null, href = null, icon = null } = link || {};
    const intl = useIntl();
    const stringLink = isString(link) ? link : null;

    return (
        <header
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isDark]: isDark,
                },
            ])}
        >
            <div className={styles.content}>
                <h2 className={classNames([styles.title])}>
                    {link !== null ? (
                        <Link
                            className={styles.titleLink}
                            {...(stringLink === null ? link : null)}
                            {...(stringLink !== null
                                ? { href: stringLink, external: false }
                                : null)}
                        >
                            {isMessage(title) ? intl.formatMessage(title) : title}
                        </Link>
                    ) : (
                        title
                    )}
                </h2>

                {children}
            </div>
            {withButton && stringLink !== null ? (
                <RoundedButton className={styles.button} href={stringLink} secondary isDark>
                    {buttonLabel}
                </RoundedButton>
            ) : null}
            {link !== null && stringLink === null && label !== null && href !== null ? (
                <IconLink
                    className={styles.moreLink}
                    icon={icon !== null ? icon : <CircledPlus />}
                    iconPosition="right"
                    isCompact
                    isDark
                    {...link}
                />
            ) : null}
        </header>
    );
};

StickyHeader.propTypes = propTypes;
StickyHeader.defaultProps = defaultProps;

export default StickyHeader;
